export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/finservicetp',
		name: 'NbuFinserviceTp',
		title: {
			single: 'NbuFinserviceTp',
			plural: 'NbuFinserviceTps'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "20001000021",
				"code": "2.06",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "15543",
				"code": "2.02",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "20001000144",
				"code": "2.07",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "15545",
				"code": "2.04",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "20001000000",
				"code": "2.08",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "20001000020",
				"code": "2.01",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "30000001000283",
				"code": "2.0",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "15544",
				"code": "2.03",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "30000001000316",
				"code": "-",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "20001000102",
				"code": "2.05",
				"name": "-",
				"caption": "-",
				"isBlocked": false
			},
			{
				"id": "20001000207",
				"code": "13.10",
				"name": "АДМІНІСТРУВАННЯ ФІНАНСОВИХ АКТИВІВ ДЛЯ ПРИДБАННЯ ТОВАРІВ У ГРУПАХ",
				"caption": "АДМІНІСТРУВАННЯ ФІНАНСОВИХ АКТИВІВ ДЛЯ ПРИДБАННЯ ТОВАРІВ У ГРУПАХ",
				"isBlocked": false
			},
			{
				"id": "20001000082",
				"code": "2.8",
				"name": "Генеральна ліцензія на здійснення валютних операцій",
				"caption": "Генеральна ліцензія на здійснення валютних операцій",
				"isBlocked": false
			},
			{
				"id": "15499",
				"code": "2.11",
				"name": "Діяльність фінансової компанії з обміну валют (за умови отримання відповідної ліцензії)",
				"caption": "Діяльність фінансової компанії з обміну валют (за умови отримання відповідної ліцензії)",
				"isBlocked": false
			},
			{
				"id": "15494",
				"code": "2.5",
				"name": "Добровільні види страхування ",
				"caption": "Добровільні види страхування ",
				"isBlocked": false
			},
			{
				"id": "20001000060",
				"code": "19.02",
				"name": "ДОВІРЧЕ УПРАВЛІННЯ ФІНАНСОВИМИ АКТИВАМИ",
				"caption": "ДОВІРЧЕ УПРАВЛІННЯ ФІНАНСОВИМИ АКТИВАМИ",
				"isBlocked": false
			},
			{
				"id": "15509",
				"code": "2.30",
				"name": "Залучення внесків (вкладів) членів кредитної спілки на депозитні рахунки",
				"caption": "Залучення внесків (вкладів) членів кредитної спілки на депозитні рахунки",
				"isBlocked": false
			},
			{
				"id": "30000001000323",
				"code": "КС2",
				"name": "ЗАЛУЧЕННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ, ЩО ПІДЛЯГАЮТЬ ПОВЕРНЕННЮ",
				"caption": "ЗАЛУЧЕННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ, ЩО ПІДЛЯГАЮТЬ ПОВЕРНЕННЮ",
				"isBlocked": false
			},
			{
				"id": "20001000196",
				"code": "13.04",
				"name": "ЗАЛУЧЕННЯ ФІНАНСОВИХ АКТИВІВ ІЗ ЗОБОВ'ЯЗАННЯМ ЩОДО НАСТУПНОГО ЇХ ПОВЕРНЕННЯ",
				"caption": "ЗАЛУЧЕННЯ ФІНАНСОВИХ АКТИВІВ ІЗ ЗОБОВ'ЯЗАННЯМ ЩОДО НАСТУПНОГО ЇХ ПОВЕРНЕННЯ",
				"isBlocked": false
			},
			{
				"id": "15503",
				"code": "2.4",
				"name": "Залучення фінансових активів юридичних осіб із зобов`язанням щодо наступного їх повернення шляхом укладання договорів на управління майном",
				"caption": "Залучення фінансових активів юридичних осіб із зобов`язанням щодо наступного їх повернення шляхом укладання договорів на управління майном",
				"isBlocked": false
			},
			{
				"id": "20001000123",
				"code": "2.40",
				"name": "Залучення фінансовою компанією коштів установників управління майном для фінансування об`єктів будівництва та/або здійснення операцій з нерухомістю (за умови отримання відповідної ліцензії)",
				"caption": "Залучення фінансовою компанією коштів установників управління майном для фінансування об`єктів будівництва та/або здійснення операцій з нерухомістю (за умови отримання відповідної ліцензії)",
				"isBlocked": false
			},
			{
				"id": "15500",
				"code": "2.25",
				"name": "Залучення фінансовою компанією коштів фізичних осіб-установників управління майном для фінансування об`єктів будівництва та/або здійснення операцій з нерухомістю (за умови отримання відповідної ліцензії)",
				"caption": "Залучення фінансовою компанією коштів фізичних осіб-установників управління майном для фінансування об`єктів будівництва та/або здійснення операцій з нерухомістю (за умови отримання відповідної ліцензії)",
				"isBlocked": false
			},
			{
				"id": "15501",
				"code": "2.12",
				"name": "Залучення фінансовою компанією фінансових активів юридичних осіб із зобов`язанням щодо наступного їх повернення",
				"caption": "Залучення фінансовою компанією фінансових активів юридичних осіб із зобов`язанням щодо наступного їх повернення",
				"isBlocked": false
			},
			{
				"id": "20001000187",
				"code": "2.14",
				"name": "Здійснення обов`язкового державного страхування",
				"caption": "Здійснення обов`язкового державного страхування",
				"isBlocked": false
			},
			{
				"id": "30000001000338",
				"code": "CK_K01_R01",
				"name": "КЛАС 1; страхування від нещасного випадку, уключаючи страхування на випадок виробничої травми та професійного захворювання",
				"caption": "КЛАС 1; страхування від нещасного випадку, уключаючи страхування на випадок виробничої травми та професійного захворювання",
				"isBlocked": false
			},
			{
				"id": "30000001000358",
				"code": "CK_K10_R01",
				"name": "КЛАС 10; страхування відповідальності власників наземних транспортних засобів, що здійснюється відповідно до Закону України “Про обов'язкове страхування цивільно-правової відповідальності власників наземних транспортних засобів”",
				"caption": "КЛАС 10; страхування відповідальності власників наземних транспортних засобів, що здійснюється відповідно до Закону України “Про обов'язкове страхування цивільно-правової відповідальності власників наземних транспортних засобів”",
				"isBlocked": false
			},
			{
				"id": "30000001000362",
				"code": "CK_K10_R03",
				"name": "КЛАС 10; страхування відповідальності під час перевезень наземним транспортним засобом (уключаючи залізничний транспорт)",
				"caption": "КЛАС 10; страхування відповідальності під час перевезень наземним транспортним засобом (уключаючи залізничний транспорт)",
				"isBlocked": false
			},
			{
				"id": "30000001000360",
				"code": "CK_K10_R02",
				"name": "КЛАС 10; страхування відповідальності, яка виникає внаслідок використання (експлуатації) наземних транспортних засобів (уключаючи залізничний транспорт), іншої, ніж визначена Законом України “Про обов'язкове страхування цивільно-правової відповідальності власників наземних транспортних засобів”",
				"caption": "КЛАС 10; страхування відповідальності, яка виникає внаслідок використання (експлуатації) наземних транспортних засобів (уключаючи залізничний транспорт), іншої, ніж визначена Законом України “Про обов'язкове страхування цивільно-правової відповідальності власників наземних транспортних засобів”",
				"isBlocked": false
			},
			{
				"id": "30000001000366",
				"code": "CK_K11_R02",
				"name": "КЛАС 11; страхування відповідальності під час перевезень повітряним судном",
				"caption": "КЛАС 11; страхування відповідальності під час перевезень повітряним судном",
				"isBlocked": false
			},
			{
				"id": "30000001000364",
				"code": "CK_K11_R01",
				"name": "КЛАС 11; страхування відповідальності, яка виникає внаслідок використання (експлуатації) повітряного судна",
				"caption": "КЛАС 11; страхування відповідальності, яка виникає внаслідок використання (експлуатації) повітряного судна",
				"isBlocked": false
			},
			{
				"id": "30000001000370",
				"code": "CK_K12_R02",
				"name": "КЛАС 12; страхування відповідальності під час перевезень водним судном",
				"caption": "КЛАС 12; страхування відповідальності під час перевезень водним судном",
				"isBlocked": false
			},
			{
				"id": "30000001000368",
				"code": "CK_K12_R01",
				"name": "КЛАС 12; страхування відповідальності, яка виникає внаслідок використання (експлуатації) водного судна",
				"caption": "КЛАС 12; страхування відповідальності, яка виникає внаслідок використання (експлуатації) водного судна",
				"isBlocked": false
			},
			{
				"id": "30000001000376",
				"code": "CK_K13_R03",
				"name": "КЛАС 13; страхування відповідальності оператора ядерної установки за ядерну шкоду, яка може бути заподіяна внаслідок ядерного інциденту, що здійснюється відповідно до\u00A0Закону України\u00A0“Про цивільну відповідальність за ядерну шкоду та її фінансове забезпечення”, без обмежень та особливостей, які дають підстави для застосування спрощеного підходу для розрахунку капіталу платоспроможності та мінімального капіталу",
				"caption": "КЛАС 13; страхування відповідальності оператора ядерної установки за ядерну шкоду, яка може бути заподіяна внаслідок ядерного інциденту, що здійснюється відповідно до\u00A0Закону України\u00A0“Про цивільну відповідальність за ядерну шкоду та її фінансове забезпечення”, без обмежень та особливостей, які дають підстави для застосування спрощеного підходу для розрахунку капіталу платоспроможності та мінімального капіталу",
				"isBlocked": false
			},
			{
				"id": "30000001000374",
				"code": "CK_K13_R02",
				"name": "КЛАС 13; страхування іншої відповідальності перед третіми особами, ніж відповідальність оператора ядерної установки за ядерну шкоду, яка може бути заподіяна внаслідок ядерного інциденту, без обмежень та особливостей, які дають підстави для застосування спрощеного підходу для розрахунку капіталу платоспроможності та мінімального капіталу",
				"caption": "КЛАС 13; страхування іншої відповідальності перед третіми особами, ніж відповідальність оператора ядерної установки за ядерну шкоду, яка може бути заподіяна внаслідок ядерного інциденту, без обмежень та особливостей, які дають підстави для застосування спрощеного підходу для розрахунку капіталу платоспроможності та мінімального капіталу",
				"isBlocked": false
			},
			{
				"id": "30000001000372",
				"code": "CK_K13_R01",
				"name": "КЛАС 13; страхування іншої відповідальності перед третіми особами, ніж відповідальність оператора ядерної установки за ядерну шкоду, яка може бути заподіяна внаслідок ядерного інциденту, з обмеженнями та особливостями, які дають підстави для застосування спрощеного підходу для розрахунку капіталу платоспроможності та мінімального капіталу",
				"caption": "КЛАС 13; страхування іншої відповідальності перед третіми особами, ніж відповідальність оператора ядерної установки за ядерну шкоду, яка може бути заподіяна внаслідок ядерного інциденту, з обмеженнями та особливостями, які дають підстави для застосування спрощеного підходу для розрахунку капіталу платоспроможності та мінімального капіталу",
				"isBlocked": false
			},
			{
				"id": "30000001000378",
				"code": "CK_K14_R01",
				"name": "КЛАС 14; страхування кредитів",
				"caption": "КЛАС 14; страхування кредитів",
				"isBlocked": false
			},
			{
				"id": "30000001000380",
				"code": "CK_K15_R01",
				"name": "КЛАС 15; страхування виданих порук (гарантій) та/або прийнятих гарантій",
				"caption": "КЛАС 15; страхування виданих порук (гарантій) та/або прийнятих гарантій",
				"isBlocked": false
			},
			{
				"id": "30000001000382",
				"code": "CK_K16_R01",
				"name": "КЛАС 16; страхування інших фінансових ризиків, крім страхування кредитів та поруки (гарантії)",
				"caption": "КЛАС 16; страхування інших фінансових ризиків, крім страхування кредитів та поруки (гарантії)",
				"isBlocked": false
			},
			{
				"id": "30000001000384",
				"code": "CK_K17_R01",
				"name": "КЛАС 17; страхування судових витрат",
				"caption": "КЛАС 17; страхування судових витрат",
				"isBlocked": false
			},
			{
				"id": "30000001000388",
				"code": "CK_K18_R02",
				"name": "КЛАС 18; страхування витрат, інших, ніж медичні, пов’язаних з наданням допомоги (асистанс) особам, які потрапили в скрутне становище під час здійснення подорожі (поїздки) на території України або за кордон",
				"caption": "КЛАС 18; страхування витрат, інших, ніж медичні, пов’язаних з наданням допомоги (асистанс) особам, які потрапили в скрутне становище під час здійснення подорожі (поїздки) на території України або за кордон",
				"isBlocked": false
			},
			{
				"id": "30000001000386",
				"code": "CK_K18_R01",
				"name": "КЛАС 18; страхування медичних витрат, пов’язаних з наданням допомоги (асистанс) особам, які потрапили в скрутне становище під час здійснення подорожі (поїздки) на території України або за кордон",
				"caption": "КЛАС 18; страхування медичних витрат, пов’язаних з наданням допомоги (асистанс) особам, які потрапили в скрутне становище під час здійснення подорожі (поїздки) на території України або за кордон",
				"isBlocked": false
			},
			{
				"id": "30000001000390",
				"code": "CK_K19_R01",
				"name": "КЛАС 19; страхування життя застрахованої особи",
				"caption": "КЛАС 19; страхування життя застрахованої особи",
				"isBlocked": false
			},
			{
				"id": "30000001000342",
				"code": "CK_K02_R02",
				"name": "КЛАС 2; медичне страхування",
				"caption": "КЛАС 2; медичне страхування",
				"isBlocked": false
			},
			{
				"id": "30000001000340",
				"code": "CK_K02_R01",
				"name": "КЛАС 2; страхування на випадок хвороби",
				"caption": "КЛАС 2; страхування на випадок хвороби",
				"isBlocked": false
			},
			{
				"id": "30000001000392",
				"code": "CK_K20_R01",
				"name": "КЛАС 20; страхування життя застрахованої особи до вступу в шлюб або до народження дитини",
				"caption": "КЛАС 20; страхування життя застрахованої особи до вступу в шлюб або до народження дитини",
				"isBlocked": false
			},
			{
				"id": "30000001000394",
				"code": "CK_K21_R01",
				"name": "КЛАС 21 - інвестиційне страхування життя",
				"caption": "КЛАС 21 - інвестиційне страхування життя",
				"isBlocked": false
			},
			{
				"id": "30000001000396",
				"code": "CK_K22_R01",
				"name": "КЛАС 22 - безперервне страхування здоров’я",
				"caption": "КЛАС 22 - безперервне страхування здоров’я",
				"isBlocked": false
			},
			{
				"id": "30000001000398",
				"code": "CK_K23_R01",
				"name": "КЛАС 23; пенсійне страхування, пов’язане з пенсійним забезпеченням застрахованої особи",
				"caption": "КЛАС 23; пенсійне страхування, пов’язане з пенсійним забезпеченням застрахованої особи",
				"isBlocked": false
			},
			{
				"id": "30000001000344",
				"code": "CK_K03_R01",
				"name": "КЛАС 3; страхування наземних транспортних засобів (крім залізничного рухомого складу)",
				"caption": "КЛАС 3; страхування наземних транспортних засобів (крім залізничного рухомого складу)",
				"isBlocked": false
			},
			{
				"id": "30000001000346",
				"code": "CK_K04_R01",
				"name": "КЛАС 4; страхування залізничного рухомого складу",
				"caption": "КЛАС 4; страхування залізничного рухомого складу",
				"isBlocked": false
			},
			{
				"id": "30000001000348",
				"code": "CK_K05_R01",
				"name": "КЛАС 5; страхування повітряних суден",
				"caption": "КЛАС 5; страхування повітряних суден",
				"isBlocked": false
			},
			{
				"id": "30000001000350",
				"code": "CK_K06_R01",
				"name": "КЛАС 6; страхування водних суден",
				"caption": "КЛАС 6; страхування водних суден",
				"isBlocked": false
			},
			{
				"id": "30000001000352",
				"code": "CK_K07_R01",
				"name": "КЛАС 7; страхування майна, що перевозиться [уключаючи вантаж, багаж (вантажобагаж)] незалежно від способу транспортування",
				"caption": "КЛАС 7; страхування майна, що перевозиться [уключаючи вантаж, багаж (вантажобагаж)] незалежно від способу транспортування",
				"isBlocked": false
			},
			{
				"id": "30000001000354",
				"code": "CK_K08_R01",
				"name": "КЛАС 8; страхування майна від вогню та небезпечного впливу природних явищ",
				"caption": "КЛАС 8; страхування майна від вогню та небезпечного впливу природних явищ",
				"isBlocked": false
			},
			{
				"id": "30000001000356",
				"code": "CK_K09_R01",
				"name": "КЛАС 9; страхування майна від шкоди, заподіяної градом, морозом, іншими подіями (уключаючи крадіжку, розбій, грабіж, умисне пошкодження/знищення майна)",
				"caption": "КЛАС 9; страхування майна від шкоди, заподіяної градом, морозом, іншими подіями (уключаючи крадіжку, розбій, грабіж, умисне пошкодження/знищення майна)",
				"isBlocked": false
			},
			{
				"id": "20001000061",
				"code": "17.00.02",
				"name": "ЛІЦЕНЗІЯ ДСТСЗІ (ДЕПАРТАМЕНТ СПЕЦІАЛЬНИХ ТЕЛЕКОМУНІКАЦІЙНИХ СИСТЕМ ТА ЗАХИСТУ ІНФОРМАЦІЇ СЛУЖБИ БЕЗПЕКИ УКРАЇНИ) НА ЗДІЙСНЕННЯ ГОСПОДАРСЬКОЇ ДІЯЛЬНОСТІ З ВИКОРИСТАННЯ Й ЕКСПЛУАТАЦІЇ КРИПТОСИСТЕМ І ЗАСОБІВ КРИПТОГРАФІЧНОГО ЗАХИСТУ",
				"caption": "ЛІЦЕНЗІЯ ДСТСЗІ (ДЕПАРТАМЕНТ СПЕЦІАЛЬНИХ ТЕЛЕКОМУНІКАЦІЙНИХ СИСТЕМ ТА ЗАХИСТУ ІНФОРМАЦІЇ СЛУЖБИ БЕЗПЕКИ УКРАЇНИ) НА ЗДІЙСНЕННЯ ГОСПОДАРСЬКОЇ ДІЯЛЬНОСТІ З ВИКОРИСТАННЯ Й ЕКСПЛУАТАЦІЇ КРИПТОСИСТЕМ І ЗАСОБІВ КРИПТОГРАФІЧНОГО ЗАХИСТУ",
				"isBlocked": false
			},
			{
				"id": "20001000040",
				"code": "17.00.01",
				"name": "ЛІЦЕНЗІЯ НА ЗДІЙСНЕННЯ ПРОФЕСІЙНОЇ ДІЯЛЬНОСТІ НА ФОНДОВОМУ РИНКУ: ДІЯЛЬНІСТЬ З УПРАВЛІННЯ АКТИВАМИ ІНСТИТУЦІЙНИХ ІНВЕСТОРІВ (ДІЯЛЬНІСТЬ З УПРАВЛІННЯ АКТИВАМИ)",
				"caption": "ЛІЦЕНЗІЯ НА ЗДІЙСНЕННЯ ПРОФЕСІЙНОЇ ДІЯЛЬНОСТІ НА ФОНДОВОМУ РИНКУ: ДІЯЛЬНІСТЬ З УПРАВЛІННЯ АКТИВАМИ ІНСТИТУЦІЙНИХ ІНВЕСТОРІВ (ДІЯЛЬНІСТЬ З УПРАВЛІННЯ АКТИВАМИ)",
				"isBlocked": false
			},
			{
				"id": "30000001000294",
				"code": "13.22",
				"name": "НАДАННЯ ГАРАНТІЙ",
				"caption": "НАДАННЯ ГАРАНТІЙ",
				"isBlocked": false
			},
			{
				"id": "20001000201",
				"code": "13.07",
				"name": "НАДАННЯ ГАРАНТІЙ ТА ПОРУЧИТЕЛЬСТВ",
				"caption": "НАДАННЯ ГАРАНТІЙ ТА ПОРУЧИТЕЛЬСТВ",
				"isBlocked": true
			},
			{
				"id": "30000001000312",
				"code": "ЛБ1",
				"name": "НАДАННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ У КРЕДИТ",
				"caption": "НАДАННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ У КРЕДИТ",
				"isBlocked": false
			},
			{
				"id": "30000001000321",
				"code": "КС1",
				"name": "НАДАННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ У КРЕДИТ",
				"caption": "НАДАННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ У КРЕДИТ",
				"isBlocked": false
			},
			{
				"id": "30000001000298",
				"code": "ФК1",
				"name": "НАДАННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ У КРЕДИТ",
				"caption": "НАДАННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ У КРЕДИТ",
				"isBlocked": false
			},
			{
				"id": "30000001000314",
				"code": "ЛБ1.1",
				"name": "НАДАННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ У КРЕДИТ У ВИГЛЯДІ ЛОМБАРДНИХ КРЕДИТІВ",
				"caption": "НАДАННЯ КОШТІВ ТА БАНКІВСЬКИХ МЕТАЛІВ У КРЕДИТ У ВИГЛЯДІ ЛОМБАРДНИХ КРЕДИТІВ",
				"isBlocked": false
			},
			{
				"id": "20001000227",
				"code": "13.06",
				"name": "НАДАННЯ КОШТІВ У ПОЗИКУ, В ТОМУ ЧИСЛІ І НА УМОВАХ ФІНАНСОВОГО КРЕДИТУ",
				"caption": "НАДАННЯ КОШТІВ У ПОЗИКУ, В ТОМУ ЧИСЛІ І НА УМОВАХ ФІНАНСОВОГО КРЕДИТУ",
				"isBlocked": false
			},
			{
				"id": "20001000199",
				"code": "2.26",
				"name": "Надання коштів у позику у тому числі і на умовах фінансового кредиту",
				"caption": "Надання коштів у позику у тому числі і на умовах фінансового кредиту",
				"isBlocked": false
			},
			{
				"id": "20001000188",
				"code": "2.44",
				"name": "Надання коштів у позику у тому числі і на умовах фінансового кредиту",
				"caption": "Надання коштів у позику у тому числі і на умовах фінансового кредиту",
				"isBlocked": false
			},
			{
				"id": "20001000192",
				"code": "2.22",
				"name": "Надання коштів у позику у тому числі і на умовах фінансового кредиту",
				"caption": "Надання коштів у позику у тому числі і на умовах фінансового кредиту",
				"isBlocked": false
			},
			{
				"id": "20001000208",
				"code": "2.45",
				"name": "Надання коштів у позику у тому числі і на умовах фінансового кредиту",
				"caption": "Надання коштів у позику у тому числі і на умовах фінансового кредиту",
				"isBlocked": false
			},
			{
				"id": "15512",
				"code": "2.34",
				"name": "Надання кредитів іншим кредитним спілкам",
				"caption": "Надання кредитів іншим кредитним спілкам",
				"isBlocked": false
			},
			{
				"id": "20001000190",
				"code": "2.48",
				"name": "Надання кредитів членам кредитної спілки за рахунок власних коштів та/або внесків (вкладів) членів кредитної спілки на депозитні рахунки",
				"caption": "Надання кредитів членам кредитної спілки за рахунок власних коштів та/або внесків (вкладів) членів кредитної спілки на депозитні рахунки",
				"isBlocked": false
			},
			{
				"id": "15517",
				"code": "2.21",
				"name": "Надання кредитною установою фінансових кредитів за рахунок власних коштів",
				"caption": "Надання кредитною установою фінансових кредитів за рахунок власних коштів",
				"isBlocked": false
			},
			{
				"id": "20001000193",
				"code": "2.20",
				"name": "Надання кредитною установою фінансових кредитів за рахунок залучених коштів",
				"caption": "Надання кредитною установою фінансових кредитів за рахунок залучених коштів",
				"isBlocked": false
			},
			{
				"id": "15515",
				"code": "2.53",
				"name": "Надання ломбардами фінансових кредитів фізичним особам за рахунок власних коштів",
				"caption": "Надання ломбардами фінансових кредитів фізичним особам за рахунок власних коштів",
				"isBlocked": false
			},
			{
				"id": "20001000209",
				"code": "2.54",
				"name": "Надання ломбардами фінансових кредитів фізичним особам за рахунок залучених коштів (за умови наявності ліцензії)",
				"caption": "Надання ломбардами фінансових кредитів фізичним особам за рахунок залучених коштів (за умови наявності ліцензії)",
				"isBlocked": false
			},
			{
				"id": "20001000191",
				"code": "2.49",
				"name": "Надання поручительств при виконанні членом кредитної спілки зобов`язань перед третіми особами",
				"caption": "Надання поручительств при виконанні членом кредитної спілки зобов`язань перед третіми особами",
				"isBlocked": false
			},
			{
				"id": "15513",
				"code": "2.35",
				"name": "Надання поручительств щодо виконання членом кредитної спілки зобов`язань перед третіми особами",
				"caption": "Надання поручительств щодо виконання членом кредитної спілки зобов`язань перед третіми особами",
				"isBlocked": false
			},
			{
				"id": "20001000194",
				"code": "2.9",
				"name": "Надання послуг з клірингу",
				"caption": "Надання послуг з клірингу",
				"isBlocked": false
			},
			{
				"id": "20001000202",
				"code": "13.08.11",
				"name": "Надання послуг з переказу коштів",
				"caption": "Надання послуг з переказу коштів",
				"isBlocked": false
			},
			{
				"id": "20001000203",
				"code": "13.11",
				"name": "НАДАННЯ ПОСЛУГ З ФАКТОРИНГУ",
				"caption": "НАДАННЯ ПОСЛУГ З ФАКТОРИНГУ",
				"isBlocked": false
			},
			{
				"id": "20001000197",
				"code": "13.05",
				"name": "НАДАННЯ ПОСЛУГ З ФІНАНСОВОГО ЛІЗИНГУ",
				"caption": "НАДАННЯ ПОСЛУГ З ФІНАНСОВОГО ЛІЗИНГУ",
				"isBlocked": false
			},
			{
				"id": "15516",
				"code": "2.36",
				"name": "Надання фінансових кредитів за рахунок залучених коштів",
				"caption": "Надання фінансових кредитів за рахунок залучених коштів",
				"isBlocked": false
			},
			{
				"id": "15518",
				"code": "2.19",
				"name": "Надання фінансових кредитів за рахунок залучених коштів",
				"caption": "Надання фінансових кредитів за рахунок залучених коштів",
				"isBlocked": false
			},
			{
				"id": "15504",
				"code": "2.24",
				"name": "Надання фінансових кредитів за рахунок залучених коштів",
				"caption": "Надання фінансових кредитів за рахунок залучених коштів",
				"isBlocked": false
			},
			{
				"id": "15505",
				"code": "2.32",
				"name": "Надання фінансових кредитів за рахунок залучених коштів",
				"caption": "Надання фінансових кредитів за рахунок залучених коштів",
				"isBlocked": false
			},
			{
				"id": "20001000189",
				"code": "2.47",
				"name": "Надання фінансових кредитів фізичним особам за рахунок власних коштів або залучення банківських кредитів",
				"caption": "Надання фінансових кредитів фізичним особам за рахунок власних коштів або залучення банківських кредитів",
				"isBlocked": false
			},
			{
				"id": "15510",
				"code": "2.31 ",
				"name": "Надання фінансових кредитів членам кредитної спілки за рахунок власних коштів",
				"caption": "Надання фінансових кредитів членам кредитної спілки за рахунок власних коштів",
				"isBlocked": false
			},
			{
				"id": "15511",
				"code": "2.33",
				"name": "Надання фінансових кредитів членам кредитної спілки за рахунок залучених коштів, крім внесків (вкладів) членів кредитної спілки на депозитні рахунки",
				"caption": "Надання фінансових кредитів членам кредитної спілки за рахунок залучених коштів, крім внесків (вкладів) членів кредитної спілки на депозитні рахунки",
				"isBlocked": false
			},
			{
				"id": "20001000204",
				"code": "2.41",
				"name": "Надання фінансовою компанією гарантій",
				"caption": "Надання фінансовою компанією гарантій",
				"isBlocked": false
			},
			{
				"id": "20001000206",
				"code": "2.42",
				"name": "Надання фінансовою компанією порук (поручительств)",
				"caption": "Надання фінансовою компанією порук (поручительств)",
				"isBlocked": false
			},
			{
				"id": "15498",
				"code": "2.10",
				"name": "Надання фінансовою компанією послуг з клірингу (за умови отримання відповідної ліцензії)",
				"caption": "Надання фінансовою компанією послуг з клірингу (за умови отримання відповідної ліцензії)",
				"isBlocked": false
			},
			{
				"id": "15502",
				"code": "2.7",
				"name": "Надання фінансовою компанією послуг фінансового лізингу",
				"caption": "Надання фінансовою компанією послуг фінансового лізингу",
				"isBlocked": false
			},
			{
				"id": "20001000200",
				"code": "2.29",
				"name": "Надання фінансовою компанією факторингу",
				"caption": "Надання фінансовою компанією факторингу",
				"isBlocked": false
			},
			{
				"id": "0",
				"code": "Н/В",
				"name": "Н/В",
				"caption": "Н/В",
				"isBlocked": false
			},
			{
				"id": "15496",
				"code": "2.3",
				"name": "Обов`язкові види страхування",
				"caption": "Обов`язкові види страхування",
				"isBlocked": false
			},
			{
				"id": "15495",
				"code": "2.2",
				"name": "Обов`язковіі види страхування (інші)",
				"caption": "Обов`язковіі види страхування (інші)",
				"isBlocked": false
			},
			{
				"id": "30000001000281",
				"code": "13.13.01",
				"name": "ОПЕРАЦІЇ З ІПОТЕЧНИМИ АКТИВАМИ З МЕТОЮ ЕМІСІЇ ІПОТЕЧНИХ ЦІННИХ ПАПЕРІВ",
				"caption": "ОПЕРАЦІЇ З ІПОТЕЧНИМИ АКТИВАМИ З МЕТОЮ ЕМІСІЇ ІПОТЕЧНИХ ЦІННИХ ПАПЕРІВ",
				"isBlocked": false
			},
			{
				"id": "15508",
				"code": "2.28",
				"name": "Операції з обслуговування дорожних чеків",
				"caption": "Операції з обслуговування дорожних чеків",
				"isBlocked": false
			},
			{
				"id": "15506",
				"code": "2.27",
				"name": "Операції з обслуговування платіжних карток",
				"caption": "Операції з обслуговування платіжних карток",
				"isBlocked": false
			},
			{
				"id": "15507",
				"code": "2.1",
				"name": "Переказ грошових коштів фінансовою компанією (за умови отримання відповідної ліцензії)",
				"caption": "Переказ грошових коштів фінансовою компанією (за умови отримання відповідної ліцензії)",
				"isBlocked": false
			},
			{
				"id": "20001000205",
				"code": "2.38",
				"name": "Переказ коштів небанківським фінансовим установам",
				"caption": "Переказ коштів небанківським фінансовим установам",
				"isBlocked": false
			},
			{
				"id": "30000001000290",
				"code": "13.20",
				"name": "ПЕРЕКАЗ КОШТІВ У НАЦІОНАЛЬНІЙ ВАЛЮТІ",
				"caption": "ПЕРЕКАЗ КОШТІВ У НАЦІОНАЛЬНІЙ ВАЛЮТІ",
				"isBlocked": false
			},
			{
				"id": "15514",
				"code": "2.37",
				"name": "Переказ кредитною спілкою грошових коштів",
				"caption": "Переказ кредитною спілкою грошових коштів",
				"isBlocked": false
			},
			{
				"id": "15497",
				"code": "12.09",
				"name": "ПОСЛУГИ В СИСТЕМІ НАКОПИЧУВАЛЬНОГО ПЕНСІЙНОГО ЗАБЕЗПЕЧЕННЯ",
				"caption": "ПОСЛУГИ В СИСТЕМІ НАКОПИЧУВАЛЬНОГО ПЕНСІЙНОГО ЗАБЕЗПЕЧЕННЯ",
				"isBlocked": false
			},
			{
				"id": "15519",
				"code": "17.09",
				"name": "ПОСЛУГИ В СИСТЕМІ НАКОПИЧУВАЛЬНОГО ПЕНСІЙНОГО ЗАБЕЗПЕЧЕННЯ В ЧАСТИНІ АДМІНІСТРУВАННЯ НЕДЕРЖАВНИХ ПЕНСІЙНИХ ФОНДІВ",
				"caption": "ПОСЛУГИ В СИСТЕМІ НАКОПИЧУВАЛЬНОГО ПЕНСІЙНОГО ЗАБЕЗПЕЧЕННЯ В ЧАСТИНІ АДМІНІСТРУВАННЯ НЕДЕРЖАВНИХ ПЕНСІЙНИХ ФОНДІВ",
				"isBlocked": false
			},
			{
				"id": "20001000185",
				"code": "3.0",
				"name": "ПОСЛУГИ У СФЕРІ СТРАХУВАННЯ В ЧАСТИНІ ПРОВЕДЕННЯ КОНКРЕТНИХ ВИДІВ СТРАХУВАННЯ, ВИЗНАЧЕНИХ ЗАКОНОДАВСТВОМ",
				"caption": "ПОСЛУГИ У СФЕРІ СТРАХУВАННЯ В ЧАСТИНІ ПРОВЕДЕННЯ КОНКРЕТНИХ ВИДІВ СТРАХУВАННЯ, ВИЗНАЧЕНИХ ЗАКОНОДАВСТВОМ",
				"isBlocked": false
			},
			{
				"id": "15800",
				"code": "11.54",
				"name": "ПОСЛУГИ У СФЕРІ СТРАХУВАННЯ, ПЕРЕСТРАХУВАННЯ, НАДАННЯ ГАРАНТІЙ",
				"caption": "ПОСЛУГИ У СФЕРІ СТРАХУВАННЯ, ПЕРЕСТРАХУВАННЯ, НАДАННЯ ГАРАНТІЙ",
				"isBlocked": false
			},
			{
				"id": "20001000184",
				"code": "11.53",
				"name": "ПОСЛУГИ У СФЕРІ СТРАХУВАННЯ; СТРАХОВІ ПОСЛУГИ",
				"caption": "ПОСЛУГИ У СФЕРІ СТРАХУВАННЯ; СТРАХОВІ ПОСЛУГИ",
				"isBlocked": false
			},
			{
				"id": "15520",
				"code": "3.01",
				"name": "Послуги, які надаються установами, що створені до набрання чинності Закону України „Про недержавне пенсійне забезпечення\" та які відповідають частині 2 Прикінцевих положень цього Закону.",
				"caption": "Послуги, які надаються установами, що створені до набрання чинності Закону України „Про недержавне пенсійне забезпечення\" та які відповідають частині 2 Прикінцевих положень цього Закону.",
				"isBlocked": false
			},
			{
				"id": "20001000198",
				"code": "13.03.11",
				"name": "Провадження діяльності з обміну валют",
				"caption": "Провадження діяльності з обміну валют",
				"isBlocked": false
			},
			{
				"id": "30000001000292",
				"code": "13.21",
				"name": "ТОРГІВЛЯ ВАЛЮТНИМИ ЦІННОСТЯМИ",
				"caption": "ТОРГІВЛЯ ВАЛЮТНИМИ ЦІННОСТЯМИ",
				"isBlocked": false
			},
			{
				"id": "30000001000308",
				"code": "ВЛ",
				"name": "ТОРГІВЛЯ ВАЛЮТНИМИ ЦІННОСТЯМИ В ГОТІВКОВІЙ ФОРМІ",
				"caption": "ТОРГІВЛЯ ВАЛЮТНИМИ ЦІННОСТЯМИ В ГОТІВКОВІЙ ФОРМІ",
				"isBlocked": false
			},
			{
				"id": "20001000143",
				"code": "2.51",
				"name": "Торгівля скупленими в населення та прийнятими під заставу ювелірними виробами та побутовими виробами з дорогоцінних металів та дорогоцінного каміння",
				"caption": "Торгівля скупленими в населення та прийнятими під заставу ювелірними виробами та побутовими виробами з дорогоцінних металів та дорогоцінного каміння",
				"isBlocked": false
			},
			{
				"id": "20001000081",
				"code": "2.50",
				"name": "Торгівля скупленими в населення та прийнятими під заставу ювелірними виробами та побутовими виробами з дорогоцінних металів та дорогоцінного каміння",
				"caption": "Торгівля скупленими в населення та прийнятими під заставу ювелірними виробами та побутовими виробами з дорогоцінних металів та дорогоцінного каміння",
				"isBlocked": false
			},
			{
				"id": "20001000195",
				"code": "13.02.13",
				"name": "УПРАВЛІННЯ МАЙНОМ ДЛЯ ФІНАНСУВАННЯ ОБ’ЄКТІВ БУДІВНИЦТВА ТА/АБО ЗДІЙСНЕННЯ ОПЕРАЦІЙ З НЕРУХОМІСТЮ ВІДПОВІДНО ДО ЗАКОНУ УКРАЇНИ “ПРО ФІНАНСОВО-КРЕДИТНІ МЕХАНІЗМИ І УПРАВЛІННЯ МАЙНОМ ПРИ БУДІВНИЦТВІ ЖИТЛА ТА ОПЕРАЦІЯХ З НЕРУХОМІСТЮ”",
				"caption": "УПРАВЛІННЯ МАЙНОМ ДЛЯ ФІНАНСУВАННЯ ОБ’ЄКТІВ БУДІВНИЦТВА ТА/АБО ЗДІЙСНЕННЯ ОПЕРАЦІЙ З НЕРУХОМІСТЮ ВІДПОВІДНО ДО ЗАКОНУ УКРАЇНИ “ПРО ФІНАНСОВО-КРЕДИТНІ МЕХАНІЗМИ І УПРАВЛІННЯ МАЙНОМ ПРИ БУДІВНИЦТВІ ЖИТЛА ТА ОПЕРАЦІЯХ З НЕРУХОМІСТЮ”",
				"isBlocked": false
			},
			{
				"id": "30000001000300",
				"code": "ФК2",
				"name": "ФАКТОРИНГ",
				"caption": "ФАКТОРИНГ",
				"isBlocked": false
			},
			{
				"id": "30000001000302",
				"code": "ФК3",
				"name": "ФІНАНСОВИЙ ЛІЗИНГ",
				"caption": "ФІНАНСОВИЙ ЛІЗИНГ",
				"isBlocked": false
			},
			{
				"id": "30000001000310",
				"code": "ФПП",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ",
				"isBlocked": false
			},
			{
				"id": "30000001000304",
				"code": "ФПП1.1",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ  ІЗ ЗДІЙСНЕННЯ ЕКВАЙРИНГУ ПЛАТІЖНИХ ІНСТРУМЕНТІВ",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ  ІЗ ЗДІЙСНЕННЯ ЕКВАЙРИНГУ ПЛАТІЖНИХ ІНСТРУМЕНТІВ",
				"isBlocked": false
			},
			{
				"id": "30000001000333",
				"code": "ФПП1.7",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ З ВИКОНАННЯ ПЛАТІЖНИХ ОПЕРАЦІЙ З РАХУНКУ/НА РАХУНОК КОРИСТУВАЧА (КРІМ ПЛАТІЖНИХ ОПЕРАЦІЙ З ЕЛЕКТРОННИМИ ГРОШИМА), ЗА УМОВИ ЩО КОШТИ ДЛЯ ВИКОНАННЯ ПЛАТ. ОПЕРАЦІЇ НАДАЮТЬСЯ КОРИСТУВАЧУ НАДАВАЧЕМ ПЛАТ. ПОСЛУГ НА УМОВАХ КРУДИТУ",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ З ВИКОНАННЯ ПЛАТІЖНИХ ОПЕРАЦІЙ З РАХУНКУ/НА РАХУНОК КОРИСТУВАЧА (КРІМ ПЛАТІЖНИХ ОПЕРАЦІЙ З ЕЛЕКТРОННИМИ ГРОШИМА), ЗА УМОВИ ЩО КОШТИ ДЛЯ ВИКОНАННЯ ПЛАТ. ОПЕРАЦІЇ НАДАЮТЬСЯ КОРИСТУВАЧУ НАДАВАЧЕМ ПЛАТ. ПОСЛУГ НА УМОВАХ КРУДИТУ",
				"isBlocked": false
			},
			{
				"id": "30000001000331",
				"code": "ФПП1.6",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ З ВИКОНАННЯ ПЛАТІЖНИХ ОПЕРАЦІЙ ІЗ ВЛАСНИМИ КОШТАМИ КОРИСТУВАЧА З РАХУНКУ/НА РАХУНОК КОРИСТУВАЧА (КРІМ ПЛАТІЖНИХ ОПЕРАЦІЙ З ЕЛЕКТРОННИМИ ГРОШИМА)",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ З ВИКОНАННЯ ПЛАТІЖНИХ ОПЕРАЦІЙ ІЗ ВЛАСНИМИ КОШТАМИ КОРИСТУВАЧА З РАХУНКУ/НА РАХУНОК КОРИСТУВАЧА (КРІМ ПЛАТІЖНИХ ОПЕРАЦІЙ З ЕЛЕКТРОННИМИ ГРОШИМА)",
				"isBlocked": false
			},
			{
				"id": "30000001000335",
				"code": "ФПП1.8",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ З ЕМІСІЇ ПЛАТІЖНИХ ІНСТРУМЕНТІВ",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ З ЕМІСІЇ ПЛАТІЖНИХ ІНСТРУМЕНТІВ",
				"isBlocked": false
			},
			{
				"id": "30000001000306",
				"code": "ФПП1.2",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ З ПЕРЕКАЗУ КОШТІВ БЕЗ ВІДКРИТТЯ РАХУНКУ ",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ З ПЕРЕКАЗУ КОШТІВ БЕЗ ВІДКРИТТЯ РАХУНКУ ",
				"isBlocked": false
			},
			{
				"id": "30000001000327",
				"code": "ФПП1.4",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ ІЗ ЗАРАХУВАННЯ ГОТІВКОВИХ КОШТІВ НА РАХУНКИ КОРИСТУВАЧІВ, А ТАКОЖ УСІ ПОСЛУГИ ЩОДО ВІДКРИТТЯ, ОБСЛУГОВУВАННЯ ТА ЗАКРИТТЯ РАХУНКІВ (КРІМ ЕЛЕКТРОННИХ ГАМАНЦІВ)",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ ІЗ ЗАРАХУВАННЯ ГОТІВКОВИХ КОШТІВ НА РАХУНКИ КОРИСТУВАЧІВ, А ТАКОЖ УСІ ПОСЛУГИ ЩОДО ВІДКРИТТЯ, ОБСЛУГОВУВАННЯ ТА ЗАКРИТТЯ РАХУНКІВ (КРІМ ЕЛЕКТРОННИХ ГАМАНЦІВ)",
				"isBlocked": false
			},
			{
				"id": "30000001000329",
				"code": "ФПП1.5",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ ІЗ ЗНЯТТЯ ГОТІВКОВИХ КОШТІВ З РАХУНКІВ КОРИСТУВАЧІВ, А ТАКОЖ УСІ ПОСЛУГИ ЩОДО ВІДКРИТТЯ, ОБСЛУГОВУВАННЯ ТА ЗАКРИТТЯ РАХУНКІВ (КРІМ ЕЛЕКТРОННИХ ГАМАНЦІВ)",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ ІЗ ЗНЯТТЯ ГОТІВКОВИХ КОШТІВ З РАХУНКІВ КОРИСТУВАЧІВ, А ТАКОЖ УСІ ПОСЛУГИ ЩОДО ВІДКРИТТЯ, ОБСЛУГОВУВАННЯ ТА ЗАКРИТТЯ РАХУНКІВ (КРІМ ЕЛЕКТРОННИХ ГАМАНЦІВ)",
				"isBlocked": false
			},
			{
				"id": "30000001000325",
				"code": "ФПП1.3",
				"name": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ (КРІМ ПОСЛУГИ З ВИПУСКУ ТА ВИКОНАННЯ ПЛАТІЖНИХ ОПЕРАЦІЙ З ЕЛЕКТРОННИМИ ГРОШИМА)",
				"caption": "ФІНАНСОВІ ПЛАТІЖНІ ПОСЛУГИ (КРІМ ПОСЛУГИ З ВИПУСКУ ТА ВИКОНАННЯ ПЛАТІЖНИХ ОПЕРАЦІЙ З ЕЛЕКТРОННИМИ ГРОШИМА)",
				"isBlocked": false
			}
		],
	},
}
